// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.myrow {
  display: flex;
}

.header {
  padding-top: 3px;
}

.no-border-radius, .no-border-radius > button {
  border-radius: 0px 0px 0px 0px;
}

.regTd {
  line-height: 18px;
  border: 1px solid #f7f7f7;
}

.smallTh {
  display: flex;
  flex-basis: 50px;
  max-width: 50px;
}

.column-change-size {
  border-radius: 0px 0px 0px 0px;
  width: 6px;
  height: 100%;
  background-color: #e7e7e7;
  color: white;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  transition: background-color 0.3s;
}

.thButtonCOl {
  display: flex;
  flex-basis: 200px;
}

.th3 {
  display: flex;
  flex-basis: 300px;
  position: relative;
  z-index: 213332;
}

.td3 {
  display: flex;
  flex-basis: 300px;
  position: relative;
  z-index: 22;
  padding: 0px 3px;
}

.td1 {
  display: flex;
  flex-basis: 100px;
}

.td1displayfield {
  display: flex;
  flex-basis: 225px;
}

.td2 {
  display: flex;
  flex-basis: 20px;
}

.td12 .checkMarkInTd {
  display: none;
}

.td12:hover .checkMarkInTd {
  display: block;
}

.tdCheckBox {
  max-height: 60px;
}

.thDisplayName {
  flex-basis: 300px;
  display: flex;
}

.td12 {
  position: relative;
  z-index: 22;
  display: flex;
  flex-basis: 40px;
  padding: 5px;
}

.td15 {
  flex-basis: 70px;
}

.tDwidtherOnHover {
  transition: flex-basis 0.3s;
}

.tDwidtherOnHover:hover span {
  width: 35px;
  padding-left: 10px;
}

.tDwidtherOnHover:hover {
  flex-basis: 65px;
  cursor: pointer;
}

.tDwidtherOnHover1:hover {
  flex-basis: 90px;
  cursor: pointer;
}

.nottDwidtherChecked {
  flex-basis: 20px;
}

.tDwidtherChecked {
  flex-basis: 70px;
  cursor: pointer;
}

.tDwidtherChecked1 {
  flex-basis: 90px;
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/app/shaps/components/view-table/table-header/table-header.component.scss"],"names":[],"mappings":"AACA;EACE,aAAA;AAAF;;AAKA;EACE,gBAAA;AAFF;;AAKA;EACE,8BAAA;AAFF;;AAIA;EACE,iBAAA;EACA,yBAAA;AADF;;AAGA;EACE,aAAA;EACA,gBAAA;EACA,eAAA;AAAF;;AAGA;EACE,8BAAA;EACA,UAAA;EACA,YAAA;EACA,yBAAA;EAIA,YAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,iCAAA;AAHF;;AAMA;EACE,aAAA;EACA,iBAAA;AAHF;;AAMA;EAIE,aAAA;EACA,iBAAA;EAIA,kBAAA;EACA,eAAA;AATF;;AAaA;EACE,aAAA;EACA,iBAAA;EACA,kBAAA;EACA,WAAA;EACA,gBAAA;AAVF;;AAaA;EACE,aAAA;EACA,iBAAA;AAVF;;AAaA;EACE,aAAA;EACA,iBAAA;AAVF;;AAaA;EACE,aAAA;EACA,gBAAA;AAVF;;AAaA;EACE,aAAA;AAVF;;AAaA;EACE,cAAA;AAVF;;AAaA;EACE,gBAAA;AAVF;;AAaA;EACE,iBAAA;EACA,aAAA;AAVF;;AAaA;EACE,kBAAA;EACA,WAAA;EACA,aAAA;EACA,gBAAA;EACA,YAAA;AAVF;;AAaA;EACE,gBAAA;AAVF;;AAiBA;EACE,2BAAA;AAdF;;AAiBA;EACE,WAAA;EACA,kBAAA;AAdF;;AAiBA;EACE,gBAAA;EACA,eAAA;AAdF;;AAiBA;EACE,gBAAA;EACA,eAAA;AAdF;;AAiBA;EACE,gBAAA;AAdF;;AAiBA;EACE,gBAAA;EACA,eAAA;AAdF;;AAiBA;EACE,gBAAA;EACA,eAAA;AAdF","sourcesContent":["\n.myrow {\n  display: flex;\n  //display: -webkit-box;\n  //border-bottom: 1px solid #a3a1a3;\n}\n\n.header {\n  padding-top: 3px;\n}\n\n.no-border-radius, .no-border-radius > button {\n  border-radius: 0px 0px 0px 0px;\n}\n.regTd {\n  line-height: 18px;\n  border: 1px solid #f7f7f7;\n}\n.smallTh {\n  display: flex;\n  flex-basis: 50px;\n  max-width: 50px;\n}\n\n.column-change-size {\n  border-radius: 0px 0px 0px 0px;\n  width: 6px;\n  height: 100%;\n  background-color: #e7e7e7;\n    //padding: 0px 2px 0px 1px;\n  //max-height: 30px;\n\n  color: white;\n  cursor: pointer;\n  user-select: none;\n  transition: background-color 0.3s;\n}\n\n.thButtonCOl {\n  display: flex;\n  flex-basis: 200px;\n}\n\n.th3 {\n  //border-width: 0px 1px 0px 0px;\n  //border-style: solid;\n  //border-color: #cacaca;\n  display: flex;\n  flex-basis: 300px;\n  //padding: 5px;\n  //color: white;\n  //height: 35px;\n  position: relative;\n  z-index: 213332;\n  //background-color: rgba(42, 45, 69, 0.95);\n}\n\n.td3 {\n  display: flex;\n  flex-basis: 300px;\n  position: relative;\n  z-index: 22;\n  padding: 0px 3px;\n}\n\n.td1 {\n  display: flex;\n  flex-basis: 100px;\n}\n\n.td1displayfield {\n  display: flex;\n  flex-basis: 225px;\n}\n\n.td2 {\n  display: flex;\n  flex-basis: 20px;\n}\n\n.td12 .checkMarkInTd {\n  display: none;\n}\n\n.td12:hover .checkMarkInTd {\n  display: block;\n}\n\n.tdCheckBox {\n  max-height: 60px;\n}\n\n.thDisplayName {\n  flex-basis: 300px;\n  display: flex;\n}\n\n.td12 {\n  position: relative;\n  z-index: 22;\n  display: flex;\n  flex-basis: 40px;\n  padding: 5px;\n}\n\n.td15 {\n  flex-basis: 70px;\n}\n\n.td12marginTop {\n  //margin-top: 5px;\n}\n\n.tDwidtherOnHover {\n  transition: flex-basis 0.3s;\n}\n\n.tDwidtherOnHover:hover span {\n  width: 35px;\n  padding-left: 10px;\n}\n\n.tDwidtherOnHover:hover {\n  flex-basis: 65px;\n  cursor: pointer;\n}\n\n.tDwidtherOnHover1:hover {\n  flex-basis: 90px;\n  cursor: pointer;\n}\n\n.nottDwidtherChecked {\n  flex-basis: 20px;\n}\n\n.tDwidtherChecked {\n  flex-basis: 70px;\n  cursor: pointer;\n}\n\n.tDwidtherChecked1 {\n  flex-basis: 90px;\n  cursor: pointer;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
